// Auto-generated skeleton for Contact

import { Person } from "./Person";

export const Contact: Api.Contact = {
  id: 0,
  hp_id: null,
  person_id: 0,
  person: Person,
  vip: 0,
  salutation: null,
  title: null,
  firstname: null,
  lastname: null,
  street: null,
  zip: null,
  city: null,
  country: null,
  search: null,
  company_function: null,
  phone_number: null,
  birthdate: null,
  birthname: null,
  birthplace: null,
  deathdate: null,
  letter_salutation: null,
  mail: null,
  ordering: 0,
  created: null,
  updated: null,
};

